<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import {isMobile} from './util/helper';

function initShoppingCart() {
    if (isMobile()) {
        return;
    }
    const isSandbox = /test/.test(location.host);
    var script = document.createElement('script');
    script.src = `https://bce.bdstatic.com/fe-static/baidu/bce-portal/shopping-cart/load.${isSandbox ? 'sandbox' : 'online'}.js`;
    script.onload = function () {
        window.shoppingCart && window.shoppingCart.setup();
    };

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

initShoppingCart();

export default {
    name: 'App',
    components: {
    }
}
</script>

<style>
#app * {
    box-sizing: border-box;
}
html, body {
    margin: 0;
}
p, h4, h2, ul, li  {
    margin: 0;
}
</style>
